import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Subgroup from "components/Next/Subgroup/Subgroup";

import * as nextReducer from "containers/Next/NextReducer";
import * as setupReducer from "containers/Setup/reducer";

class SubgroupContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Subgroup {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateSplitColumn: (column) => dispatch(setupReducer.updateSplitColumn(ownProps.runId, column)),

    createAndUpdateProject: () => dispatch(nextReducer.createAndUpdateProject(ownProps.nextId, ownProps.runId)),

    createProject: () => dispatch(nextReducer.createProject(ownProps.nextId, ownProps.runId))
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    splitOptions: setupReducer.getSplitOptions(state, ownProps.runId),
    splitColumn: setupReducer.getSplitColumn(state, ownProps.runId),

    isUpdatingProject: nextReducer.getIsUpdatingProject(state, ownProps.nextId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(SubgroupContainer);
